import { HStack } from '@starryui10/layouts/Stack';
import React from 'react';
import { SituationResponseLabel } from '../../components/SituationResponseLabel';
import { ViewPicker } from '../../components/ViewPicker';
import { ViewPickerProvider } from '../../components/ViewPicker/context/ViewPickerContext';
import { IMainDirectoryListItem } from '../../graphql/useAllMainDirectoryListQuery';
import { useDirectoryDispatch, useDirectoryState } from '../../state/DirectoryState';

export const Caption = () => {
    const { data } = useDirectoryState();
    const { dispatch } = useDirectoryDispatch();

    const handleViewPickerOnChange = (viewItem: IMainDirectoryListItem) => {
        dispatch({ type: 'CHANGE_WORKSPACE', id: viewItem.id, view: viewItem.viewType });
    };

    return (
        <HStack gap="xSmall" justifyContent="flex-start">
            <ViewPickerProvider onChange={handleViewPickerOnChange} currentView={data?.allMainDirectory?.currentView}>
                <ViewPicker />
            </ViewPickerProvider>

            <SituationResponseLabel count={data?.allMainDirectory?.totalNotOkayCount} />
        </HStack>
    );
};
